import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../actions';
import { useFirestore } from 'react-redux-firebase';
import { getDayRange } from '../utils/utils';
import collections from '../constants/FirestoreCollections';
import { useEffect } from 'react';

export const useMySupportedChats = (filter) => {
  const firestore = useFirestore();
  const profile = useSelector((state) => state.firebase.profile);
  const mySupportedChats = useSelector((state) => state.app.mySupportedChats);
  const appDispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (
          (filter.local.myChats && filter.local.myChats !== -1) ||
          mySupportedChats?.length === 0
        ) {
          const daysBeforeDate = 3; // Cantidad de dias a tomar para el filtrado de supportedChats
          const date = filter.query.date;
          const [dateStart, dateEnd] = getDayRange(date);
          dateStart.subtract(daysBeforeDate, 'day').format('L');
          const docSnapshot = await firestore
            .collection(collections.users)
            .doc(profile.token.claims.user_id)
            .get();
          if (docSnapshot.exists) {
            const supportedChats = docSnapshot.data().supportedChats || [];
            const filteredChats = supportedChats.filter((chat) => {
              const chatDate = chat.date.toDate();
              return chatDate >= dateStart && chatDate < dateEnd;
            });
            if (filteredChats !== mySupportedChats) {
              appDispatch({ type: actions.mySupportedChats, mySupportedChats: filteredChats });
            }
          }
        }
      } catch (error) {
        console.error('Error en useMySupportedChats:', error);
      }
    };

    fetchData();
  }, [filter, mySupportedChats.length]);
};
